import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepThreeExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepThreeExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) =>
    state.memoryStepThreeExtraLevels.data.memoryStepThreeExtraLevelsRandom,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
